import { render, staticRenderFns } from "./AssigneeSelector.vue?vue&type=template&id=433ef56e&scoped=true"
import script from "./AssigneeSelector.vue?vue&type=script&lang=js"
export * from "./AssigneeSelector.vue?vue&type=script&lang=js"
import style0 from "./AssigneeSelector.vue?vue&type=style&index=0&id=433ef56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ef56e",
  null
  
)

export default component.exports